<template>
  <div class="login_time">
    <img class="login_time_img" src="../assets/time.png" alt="">
    <div class="login_time_txt">时间</div>
    <div class="login_time_txt">{{ currentDate }}</div>
    <div class="login_time_txt">{{ weekday }}</div>
    <div class="login_time_txt">{{ currentTime }}</div>
  </div>
</template>

<script>export default {
  name: 'NowTime',
  data() {
    return {
      currentDate: '',
      currentTime: '',
      weekday: '',
      timer: null
    }
  },
  mounted() {
    // 立即执行一次更新
    this.updateTime();
    // 每秒更新时间
    this.timer = setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  beforeDestroy() {
    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}`;

      const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      this.weekday = weekdays[now.getDay()];

      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    }
  }
}
</script>

<style scoped lang="scss">

.login_time {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url(../assets/login_time.png);
}

.login_time_img {
  width: 21px;
  height: 21px;
}

.login_time_txt {
  font-weight: 400;
  font-size: 22px;
  color: #00FFEA;
}
</style>